require('./userGroupsBrowser.i18n.json');
require('./userGroupsBrowser.tpl.html');
require('./userGroupsBrowserRepository.js');

/*@ngInject*/
const UserGroupsBrowserController = function ($rootScope, $scope, $timeout, $state, $stateParams, coreConstant, userMediator, userGroupAction, localization, navigationStateModel) {

    localization.getTranslationByKey('userGroupsBrowser').then(function (translations) {

        $scope.viewModel = {
            isLoading: true,
            userGroups: [],
            totalUserGroups: 0,
            nameSearchString: '',
            isGridEmpty: true,
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            nameSearchStringPlaceholder: _.get(translations, 'nameSearchStringPlaceholder'),
            shortDateTimeFormat: 'MM/dd/yy hh:mma',
            title: _.get(translations, 'title'),
            emptyGridLabel: _.get(translations, 'emptyGrid'),
            searchDelayInMilliSeconds: 750,
            requestParams: {
                key: 'name',
                startIndex: 0,
                pageSize: 25,
                sortType: 'asc'
            }
        };

        $scope.actions = [];

        $scope.context = {
            identifier: 'userGroupsBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };

        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        $scope.onNameSearchStringChanged = function () {
            $scope.viewModel.requestParams.startIndex = 0;
            loadUserGroups();
        };

        function loadActions() {
            userMediator.loadUserGroupsActions().then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.actionsTimeLastModified = new Date().getTime();
            });

        }

        function loadUserGroups() {
            $scope.viewModel.isLoading = true;
            userMediator.getUserGroups($scope.viewModel.nameSearchString, $scope.viewModel.requestParams).then(function (result) {
                $scope.viewModel.userGroups = result.records;
                $scope.viewModel.totalUserGroups = result.totalRecords;
                $scope.viewModel.isGridEmpty = result.totalRecords === 0;
                $scope.viewModel.isLoading = false;
            });
        }

        $scope.getStatus = function (item) {
            return _.get(translations, 'status.' + item.status);
        };

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            loadUserGroups();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            loadUserGroups();
        };

        function resetNavigationState() {
            navigationStateModel.saveViewState('userGroups', null);
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case userGroupAction.NEW_USER_GROUP:
                        $state.go('userGroupEditor', {
                            userGroupId: -1
                        });
                        break;
                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.onClickRow = function (event, item) {
            $state.go('userGroupEditor',{
                userGroupId:item.id
            });

            let navigationModel = {
                parentState: 'userGroups',
                currentState: 'userGroupEditor',
                data: {
                    userGroupId: item.id
                }
            };

            navigationStateModel.saveViewState('userGroups', navigationModel);
        };

        loadActions();
        resetNavigationState();
        loadUserGroups();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('umCore')
    .controller('userGroupsBrowserController', UserGroupsBrowserController);
